import { Component } from '@angular/core';
import 'bootstrap/js/dist/collapse'; // collapse.js is required for the accordion to work properly

@Component({
  selector: 'app-accordion-demo',
  templateUrl: './accordion-demo.component.html',
})
export class AccordionDemoComponent {}
